import ProfileDeleteReducer, {
  Actions as ProfileDeleteActions,
  initialState as initialProfileDeleteState,
  ProfileDeleteState,
} from 'src/app/ProfileDelete/redux/profileDelete.reducer'
import ProfileInfoReducer, {
  Actions as ProfileInfoActions,
  initialState as initialProfileInfoState,
  ProfileInfoState,
} from 'src/app/ProfileInfo/redux/profileInfo.reducer'

export type ProfileState = {
  profileInfo: ProfileInfoState
  profileDelete: ProfileDeleteState
}

export const initialState: ProfileState = {
  profileInfo: initialProfileInfoState,
  profileDelete: initialProfileDeleteState,
}

export type Actions = ProfileInfoActions | ProfileDeleteActions

const ProfileReducer = (
  state = initialState,
  action: Actions,
): ProfileState => ({
  profileInfo: ProfileInfoReducer(
    state.profileInfo,
    action as ProfileInfoActions,
  ),
  profileDelete: ProfileDeleteReducer(
    state.profileDelete,
    action as ProfileDeleteActions,
  ),
})

export default ProfileReducer
